import FormSectionTitle from "../../components/styled/FormSectionTitle";

import { useGetAllUserAsDropdown } from "../../utils/user.utils";
import CustomerBankTotalField from "./CustomerBankTotalField";
import MoneyReceiptSection from "./MoneyReceiptSection";

export default function CustomerBankField({ watch, control, errors, setValue }) {
  const { data: collectors, loading } = useGetAllUserAsDropdown(``);
  const fields = [
    {
      label: "Bank Name",
      name: "customer.bank_name",
      type: "text",
      placeholder: "Bank Name",
      col: { md: 4 }
    },
    {
      label: "Branch Name",
      name: "customer.branch_name",
      type: "text",
      placeholder: "Branch Name",
      col: { md: 4 }
    },
    {
      label: "Pay Order Collector Name",
      name: "customer.pay_order_collector_name",
      type: "select",
      placeholder: "Select a name",
      col: { md: 4 },
      options: collectors ?? []
    },
    {
      label: "Unit Price",
      name: "customer.unit_price",
      type: "text",
      placeholder: "Unit Price",
      col: { md: 4 }
    },
    {
      label: "Bank Paid",
      name: "customer.bank_will_pay",
      type: "number",
      placeholder: "Bank Paid",
      col: { md: 4 }
    },
    {
      label: "Customer Paid",
      name: "customer.customer_will_pay",
      type: "number",
      placeholder: "Customer Paid",
      col: { md: 4 }
    },
    {
      name: "CustomerBankTotalField",
      type: "custom",
      customComponent: CustomerBankTotalField,
      col: { md: 12 }
    }
  ];

  const isLoading = loading;

  return (
    <>
      <MoneyReceiptSection
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        loading={isLoading}>
        <div className="col-12">
          <FormSectionTitle>Bank Loan Information</FormSectionTitle>
        </div>
      </MoneyReceiptSection>
    </>
  );
}
